import { UserManager } from 'oidc-client-ts';
import { WebStorageStateStore } from 'oidc-client-ts';
import { setAuthDetails } from '../store/authSlice'; 
import { BASE_URL } from '../config/constants';

const userManager =  new UserManager(
    {
      authority: 'https://preprodidentity.accessacloud.com',
      client_id: 'access.evo-adoption-andrada',
            client_secret: 'zzs4p1fh8DvdlMjxBS9p4peV1etOfr47wmHxsjfGJuStGO4RXaUmfjPNEMq2R0Hq',
      redirect_uri: `${BASE_URL}/oidc/client`,
      response_type: 'code',
      scope: 'openid profile email policy access.evo-adoption-andrada.api',
      userStore: new WebStorageStateStore({ store: window.localStorage }),
      stateStore: new WebStorageStateStore({ store: window.localStorage }),
      post_logout_redirect_uri: `${BASE_URL}/login`,
      // Silent renew configuration for native tab support
      silent_redirect_uri: `${BASE_URL}/oidc/silent`,
    } 
  )
let reduxStore = null;

export function setStore(store) {
  reduxStore = store;
}

export async function getUser() {
  try {
    const user = await userManager.getUser();
    if (!user) {
      console.warn('No user found. Ensure the user is logged in.');
      return null;
    }

    if (reduxStore) {
      reduxStore.dispatch(
        setAuthDetails({
          idToken: user.id_token,
          accessToken: user.access_token,
          user: user.profile,
        })
      );
    }
    return user;
  } catch (error) {
    console.error('Error fetching user:', error);
    return null;
  }
}

export async function getAccessToken() {
    const user = await getUser();
    return user?.access_token;
}

export async function isAuthenticated() {
    let token = await getAccessToken();

    return !!token;
}

export async function sendOAuthRequest() {
    return await userManager.signinRedirect();
}

/**
 * Attempts silent authentication using the existing Identity session.
 * This is used in native tab scenarios where the platform has already authenticated the user.
 * Uses prompt=none to avoid any interactive UI.
 * @returns {Promise<User|null>} The user if silent auth succeeds, null otherwise
 */
export async function trySilentSignIn() {
    try {
        console.log('Attempting silent sign-in...');
        const user = await userManager.signinSilent();
        if (user && reduxStore) {
            reduxStore.dispatch(
                setAuthDetails({
                    idToken: user.id_token,
                    accessToken: user.access_token,
                    user: user.profile,
                })
            );
        }
        console.log('Silent sign-in successful');
        return user;
    } catch (error) {
        console.log('Silent sign-in failed:', error.message);
        return null;
    }
}

export async function handleOAuthCallback(callbackUrl) {
    try {
        const user = await userManager.signinRedirectCallback(callbackUrl)
        if (user && reduxStore) {
            reduxStore.dispatch(
              setAuthDetails({
                idToken: user.id_token,
                accessToken: user.access_token,
                user: user.profile,
              })
            );
          } else if (!reduxStore) {
            console.warn('Redux store not initialized. Call setStore() before handling OAuth callback.');
        }
        return user;
    } catch(e) {
        alert(e);
        console.log(`error while handling oauth callback: ${e}`);
    }
}

export async function handleLogout() {
    await userManager.clearStaleState()
    await userManager.signoutRedirect();
    if (reduxStore) {
    reduxStore.dispatch(setAuthDetails(null));
    } else {
        console.warn('Redux store not initialized. Call setStore() before logout.');
    }
}
